// Centralised API base URLs.
// Values come from the .env.production / .env.staging / .env.development files
// (loaded automatically by react-scripts, or via `env-cmd` for the build:* scripts).
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.al-jariyah.com/api';
export const CP_API_URL = process.env.REACT_APP_CP_API_URL || 'https://cp-api.al-jariyah.com/admin';

// Portal yang dipautkan keluar dari laman ini — bukan API, tetapi destinasi
// butang "Log Masuk" dan "Sertai Kami".
//
// Ini dahulunya ternary pada process.env.NODE_ENV, yang TIDAK berfungsi seperti
// yang dijangka: react-scripts build memaksa NODE_ENV="production" untuk setiap
// build, termasuk build:stg. Jadi build staging menilai syarat itu sebagai benar
// dan menghantar pengguna staging ke portal produksi. REACT_APP_ENV ialah suis
// sebenar kerana ia datang daripada fail .env yang dipilih env-cmd.
export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL || 'https://cp.al-jariyah.com';
export const KARIAH_URL = process.env.REACT_APP_KARIAH_URL || 'https://kariah.al-jariyah.com';
